<div class="row w1024">
  <div class="col-md-12">
    <fieldset class="file-upload">
      <legend [translate]="'TITLES.ATTACH_PRODUCT_FILES'"
        >Attach Product Files / Pictures
      </legend>

      <!-- <div class="form-group">
				<input type="file" class="form-control" id="files" multiple
					(change)="handleFileInput($event)" />
			</div> -->

      <div>
        <table class="table table-striped table-hover">
          <thead>
            <tr>
              <th [translate]="'TITLES.FILE'">File</th>
              <th [translate]="'TITLES.FILE_REMARKS'">File Remarks/Description</th>
              <!-- <th>&nbsp;</th> -->
            </tr>
          </thead>
          <tfoot *ngIf="rfq && rfq.rfq_attachments">
            <tr *ngFor="let file of rfq.rfq_attachments; let i = index">
              <td>
                <span></span>
                <span *ngIf="file.thumburl">
                  <a target="_blank" href="{{ url + '/file?f=' + file.filename }}">
                    <img
                      src="{{ url + '/file?f=' + file.thumburl }}"
                      width="50"
                      alt="{{ file.fileurl }}"
                    />
                  </a>
                </span>
                <span *ngIf="!file.thumburl">
                  <a
                    href="{{ url + '/file?f=' + file.filename }}"
                    class="mr-4"
                    target="_blank"
                    *ngIf="!file.thumburl"
                  >
                    <i class="fas fa-file fa-fw"></i>
                    {{
                      file.remarks && file.remarks.trim() != ''
                        ? file.remarks
                        : file.fileurl && file.fileurl != ''
                          ? file.fileurl
                          : file.name && file.name != ''
                            ? file.name
                            : 'File ' + (i + 1)
                    }}
                  </a>
                </span>
              </td>
              <td>
                {{ file.remarks }}
              </td>
              <!-- <td class="actions text-right">
								<a href="javascript:;" class="text-danger" title="Delete file"
									(click)="deleteFile(file,i);">
									<i class="fas fa-trash"></i>
								</a>
							</td> -->
            </tr>
          </tfoot>
        </table>
      </div>
    </fieldset>
  </div>
</div>
